import type { CoreState } from '@/core/store/types'
import { type Brand } from '@/core/types'

export const getBrandById =
  (state: CoreState) =>
  (id: string): Brand | undefined => {
    return state.brands.find((brand) => brand.id === id)
  }
